import isEqual from 'lodash/fp/isEqual';
import pick from 'lodash/fp/pick';

import { PlayerBlockProps } from '.';

const pickProps = pick<PlayerBlockProps, keyof PlayerBlockProps>([
  'title',
  'width',
  'height',
  'hasTag',
  'preview',
  'statuses',
  'modified',
  'duration',
  'hostedId',
  'videoSrc',
  'isPending',
  'isHovered',
  'actions',
  'showProgress',
  'uploadProgress',
  'canStreamVideo',
  'actionsDividerIndex'
]);

export const arePlayerBlockPropsEqual = (prev: PlayerBlockProps, next: PlayerBlockProps) => {
  const otherPrev = pickProps(prev);
  const otherNext = pickProps(next);

  return isEqual(otherPrev, otherNext);
};
